import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import WorkSheet from "../../../containers/modules/report/work-sheet";
import CashReport from "../../../containers/modules/report/cash-report";

export default function CashReportRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="cash-report"
      index
      element={
        <AccessControl
          name={"Cash Report Show"}
          auth={authUser}
          component={() => <CashReport />}
        />
      }
    ></Route>
  );
}
